import Selector from 'common/i18n/Selector';
import languages from 'common/i18n/utils/languages';
import UserApi from 'pc-sales/api.v2/user';
import * as React from 'react';

export default () => ({
    key: 'LANG',
    title: <Selector showIcon={true} />,
    children: languages.getDisplay().map(({ key, name }: any) => {
        return {
            key: key,
            title: (
                <div className="badge">
                    <a
                        onClick={async () => {
                            try {
                                // 更新当前登录用户语言
                                await UserApi.updateLanguage({ language: key });
                            } finally {
                                await languages.set(key);
                            }
                        }}
                    >
                        <span style={{ marginLeft: 8 }}>{name}</span>
                    </a>
                </div>
            ),
        };
    }),
});
